<p-toast position="top-right" [life]="5000">
  <ng-template let-message pTemplate="message">
    <div
      class="notification-toast-content"
      [class.clickable]="message.data?.purchaseOrderId"
      (click)="onToastClick(message)">
      <div class="flex flex-column gap-2">
        <div class="font-bold text-base">{{ message.summary }}</div>
        <div class="text-sm">{{ message.detail }}</div>
      </div>
    </div>
  </ng-template>
</p-toast>

<div *ngIf="isAuthenticated === false">
  <router-outlet></router-outlet>
</div>

<div class="layout-container" *ngIf="isAuthenticated === true"
  [ngClass]="{'rtl': currentLang === 'ar', 'ltr': currentLang === 'en'}">
  <!-- Topbar -->
  <app-topbar (toggleSidebar)="toggleSidebar()"></app-topbar>
  <div class="content-wrapper">
    <!-- Fixed Sidebar -->
    <div class="sidebar" [ngClass]="{'open': isSidebarOpen}" (click)="$event.stopPropagation()">
      <app-sidebar></app-sidebar>
    </div>
    <!-- Main Content -->
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-tour-overlay></app-tour-overlay>
</div>